import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'team-selector.title',
		defaultMessage: 'Contributing teams',
		description: 'Title for the contributing teams section in the team selector component',
	},
});

export default messages;
